import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Section } from '../../02-Molecules/Section/Section'

import { FormCheckbox } from "../../01-Atoms/FormCheckbox/FormCheckbox";
import { AddressLookUp } from "../../02-Molecules/AddressLookUp/AddressLookUp";

/**
 * SectionBillingAddress component.
 */
export const SectionBillingAddress = forwardRef(({ collapsed, heading, headingLarge,loqateKey, sectionId, tracking, trackingEvent, validationHash, values, ...props }, ref) => {
  return (
    <Section tracking={tracking} trackEvent={trackingEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId}>
      <FormCheckbox
        checked={values.use_contact_address}
        label={'Use contact address'}
        name={'use_contact_address'}
        onInputChange={props.onInputChange}
      />

      {!values.use_contact_address &&
      <AddressLookUp
        loqateKey={loqateKey}
        legend={'Billing address'}
        names={{
          addressLine1: 'billing_address_line_1',
          addressLine2: 'billing_address_line_2',
          townCity    : 'billing_address_town_city',
          postCode    : 'billing_address_post_code',
        }}
        showLookup={true}
        onInputChange={props.onInputChange}
        validationHash={validationHash}
        values={{
          addressLine1: values.billing_address_line_1,
          addressLine2: values.billing_address_line_2,
          townCity    : values.billing_address_town_city,
          postCode    : values.billing_address_post_code,
        }}/>
      }
    </Section>
  )
})


/**
 * SectionBillingAddress PropTypes.
 */
SectionBillingAddress.propTypes = {
  loqateKey      : PropTypes.string,
  collapsed      : PropTypes.bool,
  heading        : PropTypes.string,
  headingLarge   : PropTypes.bool,
  sectionId      : PropTypes.string,
  validationHash : PropTypes.string,
  onInputChange  : PropTypes.func,
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values: PropTypes.shape({
    payment_amount           : PropTypes.string,
    payment_nonce            : PropTypes.string,
    first_name               : PropTypes.string,
    last_name                : PropTypes.string,
    email_address            : PropTypes.string,
    telephone_number         : PropTypes.string,
    use_contact_address      : PropTypes.bool,
    contact_address_line_1   : PropTypes.string,
    contact_address_line_2   : PropTypes.string,
    contact_address_town_city: PropTypes.string,
    contact_address_post_code: PropTypes.string,
    billing_address_line_1   : PropTypes.string,
    billing_address_line_2   : PropTypes.string,
    billing_address_town_city: PropTypes.string,
    billing_address_post_code: PropTypes.string,
    order_id                 : PropTypes.string,
    uuid                     : PropTypes.string,
  })
}
